// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';

export class LMCheckControlEvent implements LMFieldEvent {
  layoutObject: LMCheckControl;
  event: Event;
  eventType: LMFieldEventType;
  isChecked: boolean;

  constructor(event: Event, layoutObject: LMCheckControl, isChecked: boolean) {
    this.eventType = 'CheckControlEvent';
    this.event = event;
    this.layoutObject = layoutObject;
    this.isChecked = isChecked;
  }
}

enum LMCheckControlTypeDisplayEnum {
  STAR = 0,
  BOX,
  SWITCH
}

@Component({
  selector:    'lm-checkcontrol',
  templateUrl: './lm-checkcontrol.component.html',
  styleUrls:   [ 'lm-checkcontrol.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class LMCheckcontrolComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {
  @Input() layoutObject: LMCheckControl;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;
  @Input() lmColumnLayoutInfo: LMColumnLayoutInfo;
  @Input() lmParagraphLayoutInfo: LMParagraphLayoutInfo;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  public displayType: LMCheckControlTypeDisplayEnum;
  public layoutDisplayType;

  constructor(protected lmFieldServiceAdapter: LMFieldServiceAdapter) {
    super(lmFieldServiceAdapter);
    this.layoutDisplayType = LMCheckControlTypeDisplayEnum;
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    if (this.layoutObject.displayAsSwitch) {
      this.displayType = LMCheckControlTypeDisplayEnum.SWITCH;
      this._fieldClassArray.push('switch');

    } else if (this.layoutObject.displayAsStar) {
      this.displayType = LMCheckControlTypeDisplayEnum.STAR;

    } else {
      this.displayType = LMCheckControlTypeDisplayEnum.BOX;

    }

    this.setFieldClasses();
    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onClickEvent(event: Event) {
    this.fieldEvent.emit(new LMCheckControlEvent(event, this.layoutObject, !this.modelField.value));
  }

  get hasCheckedState(): boolean {
    // TODO: needs to call isReadonly() as well as check to see if the actions are valid

    // execute isReadonly()
    //    if true, return true as validWhen is in place
    //    if false, then evaluate the following:
    // if this.layoutObject.hasCheckedState === true, then set mutability based on first valid unchecked action
    // if this.layoutObject.hasCheckedState === false, then set mutability based on first valid checked action

    // null turns off readOnly/disabled state
    return null;
  }
}
